/// <amd-module name="Wit/SprintsHub/SprintsView/Components/SprintPickerItem" />
import * as React from "react";
import { Icon, IconSize } from "VSSUI/Icon";
import { Pill } from "VSSUI/Pill";
import { Tooltip } from "VSSUI/TooltipEx";

interface ISprintPickerItemProps {
    text: string;
    pillText: string;
    pastOrFuture: boolean;
}

export function SprintPickerItem({ text, pillText, pastOrFuture }: ISprintPickerItemProps) {
    return (
        <td className="flex-row text-ellipsis">
            <Icon size={IconSize.medium} className="flex sprint-picker-item-icon" iconName="Sprint" />
            <Tooltip overflowOnly={true}>
                <span className="flex padding-8 text-ellipsis">{text}</span>
            </Tooltip>
            <span className="flex padding-8 sprint-picker-item-right">
                <Pill className={pastOrFuture ? "sprint-picker-pill-not-current" : "sprint-picker-pill-current"}>{pillText}</Pill>
            </span>
        </td>
    );
}
